import { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from 'src/cms/layout/core'
import CardComponent from './CardComponent'

const DashboardWrapper: FC = () => {
  const intl = useIntl()

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <CardComponent />
    </>
  )
}

export { DashboardWrapper }
